<template>

    <div v-ripple class="area-list-item-container d-flex justify-space-between" @click="show(areaShowed._id)" :id="areaShowed._id" :ref="areaShowed._id">
        <div class="div">
            <div class="d-flex justify-space-between" @click="setCenter">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <label @click="setCenter" v-on="on" class="area-list-item-label-name area-list-item-label">{{ areaShowed.name }}</label>
                    </template>
                    <span class="area-name">{{areaShowed.name}}</span>
                </v-tooltip>
                <label class="area-list-item-label-quantity area-list-item-label">{{areaShowed.kmSquare}} km²</label>
            </div>
            <v-progress-linear @click="setCenter" height="8px" :color="areaShowed.color" :value="(areaShowed.kmSquare / 25) * 100" />
        </div>
        <v-btn  @click="openDialog" icon text>
            <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-dialog v-if="dialog" v-model="dialog" width='600' hide-overlay transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('provider_dashboard.config')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-list three-line>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn :disabled='loading' fab icon color='red' @click="deleteArea">
                                <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('provider_dashboard.delete')}}</v-list-item-title>
                            <v-list-item-subtitle>{{$t('provider_dashboard.delete_msg')}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { DELETE_AREA, GET_POLYS, SET_AREAS, SET_CENTER_MAP, SET_POLYS, SET_ZOOM } from '../../../store/mutations';

export default {
    name: 'AreaListItem',

    props: {
        area: Object,
    },

    computed: {
        ...mapGetters({ provider: 'ProviderVuex/provider', page: 'AreaVuex/mapPage' }),

        showArea() {

            return this.area

        }
    },

    data() {
        return {
            dialog: false,
            areaShowed: this.area,
            loading: false
        }
    },

    methods: {

        show(ref) {

            const refsData = 'polygon_' + ref

            this.$emit('clickedOnList', refsData)

        },

        ...mapMutations({
            setCenterMap: `AreaVuex/${SET_CENTER_MAP}`,
            setZoom: `AreaVuex/${SET_ZOOM}`,
            setPolys: `AreaVuex/${SET_POLYS}`,
            setAreas: `AreaVuex/${SET_AREAS}`
        }),

        ...mapActions({
            deleteSelectedArea: `AreaVuex/${DELETE_AREA}`,
            getAreas: `AreaVuex/${GET_POLYS}`,
        }),

        async cleanPolyData() {

            await this.setPolys([])
            await this.setAreas([])

        },

        openDialog() {

            this.dialog = true

        },

        async deleteArea() {

            this.loading = true;

            let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

            try {

                await this.deleteSelectedArea(this.areaShowed._id)

                await this.cleanPolyData()

                await this.getAreas({ page: this.page, id: this.provider._id })

                return this.showToast(this.$t('provider_dashboard.toast_area_delete_msg'), this.$t('provider_dashboard.toast_area_delete_title'), 'success')

            } catch (error) {

                console.log(error)

                return this.showToast(this.$t('provider_dashboard.toast_area_error_delete_msg'), this.$t('provider_dashboard.toast_area_error_delete_title'), 'error')

            } finally {

                this.loading = false;
                this.areaShowed = null
                this.dialog = false
                loader.hide();

            }

        },

        setCenter() {

            var x = this.area.polygon.coordinates[0].map(xy => xy[1]);
            var y = this.area.polygon.coordinates[0].map(xy => xy[0]);
            var cx = (Math.min(...x) + Math.max(...x)) / 2;
            var cy = (Math.min(...y) + Math.max(...y)) / 2;

            this.setCenterMap({ lat: cx, lng: cy })

            if(this.area.kmSquare < 10) return this.setZoom(14)
            if(this.area.kmSquare < 50) return this.setZoom(14)
            if(this.area.kmSquare < 150) return this.setZoom(14)
            if(this.area.kmSquare < 200) return this.setZoom(10)
            if(this.area.kmSquare > 1000) return this.setZoom(8)

            return this.setZoom(15)

        }
    },
};
</script>

<style scoped>
    .area-list-item-container {
        width: 180px;
        cursor: pointer
    }

    .area-list-item-label {
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        width: 180px;
    }

    .div {

        width: 100%;
        max-width: 180px;

    }

    .area-list-item-label-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 10px;
        cursor: pointer
    }

    .area-list-item-label-quantity {
        color: #50D362;
        font-size: 11px;
        white-space: nowrap;
        cursor: pointer
    }
</style>
